import request from '@/utils/request'
// 统计数据
export function statistics(data){
	return request({
    url: '/admin/Webapi/statistics',
    method: 'POST',
    data: data || {}
  })
}
//支付
export function buycourse(data) {
    return request({
        url: '/api/index/buycourse',
        method: 'POST',
        data: data || {}
    })
}
//转送支付
export function get_gift(data) {
    return request({
        url: '/api/gift/get_gift',
        method: 'POST',
        data: data || {}
    })
}
// 辅导付款
export function wxpay(data){
  return request({
    url: '/admin/Webapi/wxpay',
    method: 'POST',
    data: data || {}
  })
}
// 7天训练营付款
export function createOrder(data){
  return request({
    url: '/api/Seven/createOrder',
    method: 'POST',
    data: data || {}
  })
}
// 课程联报支付接口
export function buyCourseOffers(data) {
  return request({
    url: '/api/Joint_Offers/buyCourse',
    method: 'POST',
    data: data || {}
  })
}
// 7天职业定位特训营---支付
export function activity_order(data){
  return request({
    url: '/api/seven/activity_order',
    method: 'POST',
    data: data || {}
  })
}
// 拼团功能---支付
export function scrabbleBuy(data){
  return request({
    url: '/api/index/scrabbleBuy',
    method: 'POST',
    data: data || {}
  })
}
// 测评新系统---支付
export function buy_product(data){
  return request({
    url: '/admin/ceping/buy_product',
    method: 'POST',
    data: data || {}
  })
}
// 测评新系统---支付
export function ext_buy_product(data){
  return request({
    url: '/admin/ext_ceping/buy_product',
    method: 'POST',
    data: data || {}
  })
}